import React, { useState } from 'react';

import './Devices.scss';

import Modal from 'react-modal';
import { useQuery } from '@apollo/client';
import gqlSchemaLibrary from '../services/graphql.schemas';
import { Subject } from 'rxjs';
import ButtonIcon from '../forms/buttons/Button.icon';
import {useNavigate} from 'react-router-dom';
import SpinnerLoader from "../visuals/SpinnerLoader";
import {useTranslation} from "react-i18next";
import {PageViewLog} from "../services/interactions/page.view";
import AuditTrail, {PAGES} from "../services/interactions/audit.trail";

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        border: "none",
        padding: "0px",
        boxShadow: "0 3px 8px 0 rgba(0, 0, 0, 0.38)",
    }
};

Modal.setAppElement('#root');

function DevicesBase({ match, currentUser, toaster }) {
    const {t} = useTranslation(['devices','common','menu'])
    const [peripherals, setPeripherals] = useState({ deviceSummary: [] });
    const [activeTab, setActiveTab] = useState('inventory');
    const [loadData, setLoadData] = useState(true);
    const [showModalOrder, setShowModalOrder] = useState(false);

    const [searchFocused, changeSearchFocused] = useState(false);
    const [search, changeSearch] = useState('');
    const [searchTerm] = useState(new Subject());
    const navigate = useNavigate();

    useQuery(gqlSchemaLibrary.devices.peripherial.query.getPeripherialsSummary, {
        onCompleted: ({ getPeripherialsSummary }) => {
            if (getPeripherialsSummary) {
                console.log('Device summary: ', getPeripherialsSummary);
                const devices = getPeripherialsSummary.slice().sort((a, b) => {
                    const displayNameA = a.displayName? a.displayName : '';
                    const displayNameB = b.displayName? b.displayName : '';
                    return displayNameA.localeCompare(displayNameB);
                });
                setPeripherals({ deviceSummary: devices });
            }
            setLoadData(false);
        },
        fetchPolicy: 'cache-and-network'
    });

    const handleFocus = (bool) => {
        return () => {
            changeSearchFocused(bool);
        }
    }

    const handleSearch = (e) => {
        const value = e.target.value;
        changeSearch(value);
        searchTerm.next(value);
    }

    const onChangeTab = (tab) => {
        return () => {
            setActiveTab(tab);
        }
    }

    const closeDeviceModal = () => {

    }

    const renderModal = () => {
        return (
            <Modal
                isOpen={false}
                onRequestClose={closeDeviceModal}
                style={customStyles}
                contentLabel={t('assign-patch-device')}
            >
                <p>{t('for-device-csv')}</p>
            </Modal>
        )
    }

    const createOrder = () => {
        setShowModalOrder(true);
    }

    const renderSvgByType = (deviceSubtype) => {
        deviceSubtype = deviceSubtype.toLowerCase();
        if (deviceSubtype === 'biosticker') {
            return (
               <img src ="https://cherishhealth-assets.s3.us-east-2.amazonaws.com/biosticker.png" width="100px"/>
            )
        } else if (deviceSubtype === 'biosensor patch') {
            return (
                <svg width="60px" height="60px" viewBox="0 0 44 44" version="1.1" xmlns="http://www.w3.org/2000/svg">
                    <g id="CardioPatch" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M35.3830123,26.8521739 C34.1506636,26.8521739 32.9975718,27.1873033 32.0107263,27.7692185 C30.7542139,26.1799947 30.0051392,24.1769005 30.0051392,22 C30.0051392,19.8221392 30.7542139,17.8190451 32.0107263,16.2298213 C32.9975718,16.8126967 34.1506636,17.1468658 35.3830123,17.1468658 C39.0375304,17.1468658 42,14.203681 42,10.5729528 C42,6.94318485 39.0375304,4 35.3830123,4 C32.2117683,4 29.5624602,6.21627101 28.9168061,9.17481995 C26.5468304,8.56505735 24.0618355,8.24145105 21.5004833,8.24145105 C18.9381645,8.24145105 16.4531696,8.56505735 14.0831939,9.17481995 C13.4385063,6.21627101 10.7882317,4 7.61698767,4 C3.96246965,4 1,6.94318485 1,10.5729528 C1,14.203681 3.96246965,17.1468658 7.61698767,17.1468658 C8.84933638,17.1468658 10.0024282,16.8126967 10.9902402,16.2298213 C12.2457861,17.8190451 12.9948608,19.8221392 12.9948608,22 C12.9948608,24.1769005 12.2457861,26.1799947 10.9902402,27.7692185 C10.0024282,27.1873033 8.84933638,26.8521739 7.61698767,26.8521739 C3.96246965,26.8521739 1,29.7953588 1,33.426087 C1,37.0568152 3.96246965,40 7.61698767,40 C10.1087484,40 12.2786487,38.6306748 13.4075768,36.6093358 C13.7275042,36.0927181 14.7104835,35.2793812 15.7031283,36.2617231 C17.1896792,37.7328354 19.2358613,38.6469992 21.5004833,38.6469992 C23.7641387,38.6469992 25.8103208,37.7328354 27.2968717,36.2617231 C28.290483,35.2793812 29.2724958,36.0927181 29.5924232,36.6093358 C30.7213513,38.6306748 32.8912516,40 35.3830123,40 C39.0375304,40 42,37.0568152 42,33.426087 C42,29.7953588 39.0375304,26.8521739 35.3830123,26.8521739 Z" id="Stroke-1" stroke="#231F20" strokeWidth="1.55200005" fill="#FFFFFF"></path>
                    </g>
                </svg>
            )
        } else if (deviceSubtype === 'spo2 reader') {
            return (
                 <img src ="https://cherishhealth-assets.s3.us-east-2.amazonaws.com/nonin3230.png" width="100px"/>
               )
        } else if (deviceSubtype === 'phone') {
            return (
                <svg xmlns="http://www.w3.org/2000/svg" width="64px" height="75px" viewBox="0 0 30 90" >
                    <g fillRule="evenodd" fill="none" id="Safe@Home-Kit-assignment">
                        <g stroke="null" strokeWidth="2" id="Kit-assignment:-one-device-menu">
                            <g stroke="null" id="Group-3">
                                <path stroke="#000000" fill="#FFFFFF" id="Combined-Shape" d="m41.811174,5c2.250903,0 4.087134,1.781037 4.184749,4.014947l0.004078,0.187177l0,69.531207c0,2.908701 -2.350504,5.266667 -5.25,5.266667l-31.5,0c-2.899496,0 -5.25,-2.357966 -5.25,-5.266667l0,-64.264541c0,-2.908692 2.350504,-5.266667 5.25,-5.266667l21.875,0l0,0c0,-2.320765 1.875405,-4.202124 4.188826,-4.202124l6.497348,0z"/>
                                <path stroke="#000000" id="Rectangle" d="m11,16.765961l28,0c0.966499,0 1.75,0.785989 1.75,1.755556l0,51.868502c0,0.969567 -0.783501,1.755556 -1.75,1.755556l-28,0c-0.966499,0 -1.75,-0.785989 -1.75,-1.755556l0,-51.868502c0,-0.969567 0.783501,-1.755556 1.75,-1.755556z"/>
                            </g>
                        </g>
                    </g>
                </svg>
            )
        }else if (deviceSubtype === 'pressure cuff' || deviceSubtype === 'blood pressure cuff') {
            return (
                //
                <img src ="https://cherishhealth-assets.s3.us-east-2.amazonaws.com/bt105.png" width="100px"/>
            )
        }else if (deviceSubtype === 'weight scale') {
            return (
               <img src ="https://cherishhealth-assets.s3.us-east-2.amazonaws.com/bt005.png" width="100px"/>
            )
        }

        else if (deviceSubtype === 'wellue spo2 reader') {
            return (
                <img src ="https://cherishhealth-assets.s3.us-east-2.amazonaws.com/oxysmart.png" width="100px"/>
            )
        }else if (deviceSubtype === 'glucometer') {
            return (
                <img src ="https://cherishhealth-assets.s3.us-east-2.amazonaws.com/nextone.png" width="100px"/>
            )
        }
        else if (deviceSubtype === 'biobutton') {
            return (
                <img src ="https://cherishhealth-assets.s3.us-east-2.amazonaws.com/biobutton.png" width="180px"/>
            )
        }else if (deviceSubtype === 'cherish serenity') {
            return (
              <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="60px" height="80px" viewBox="0 0 452 576">
                <g>
                    <path fill="#279AD5" d="M0.3,413.5c3.6-6.9,9.1-8.4,16.6-7.5c23.3,2.9,46.7,4.9,70.1,6.3c28.8,1.8,57.6,2.3,86.4,0.9
                        c44.3-2.2,87.7-9.2,128.2-28.8c42.1-20.4,72.8-52.5,95.2-93.1c14-25.4,25-52,28.8-80.9c4.2-32.1,6.7-64.5-1.5-96.3
                        c-12.7-49-56.4-84.7-106.6-88.8c-4.8-0.4-9.6-0.6-14.5-0.6c-52.8,0-105.6,0-158.4,0c-57.8,0-108.8,42.6-119.1,99.5
                        c-1.3,7.4-2,14.8-2,22.3c0.1,64.3,0,128.6,0,192.9c0,9.6-5.3,15-13.4,13.9c-4.9-0.7-7.3-4.2-9.5-8c0-72,0-144,0-215.9
                        c1.4-6.6,1.5-13.4,3.3-20c6.9-25.7,19.7-48.1,38.4-66.7c20.4-20.2,45-33.5,73.4-39.3c2.1-0.4,4.2-1,6.4-1.3
                        c6.9-1.4,13.9-1.6,20.8-1.6c52.3-0.1,104.5,0,156.8-0.1c13.8,0,27.6,0.4,41.1,3.7c27.6,6.9,51.6,20.2,71.3,40.8
                        c20.7,21.6,33.8,47.1,38.9,76.7c0.6,3.6-0.1,7.3,0.9,10.9c0,3.2,0,6.5,0,9.7c0,97.4,0,194.8,0,292.2c0,3.3,0,6.5,0,9.8
                        c-0.7,18.8-6.2,36.4-15,52.8c-21.9,40.7-55.5,66.3-100.7,76.2c-6.7,1.5-13.5,1.6-20.3,1.6c-57.6,0-115.3,0-172.9,0
                        c-1.8,0-3.7-0.5-5.4,0.5c-2.7,0-5.3,0-8,0c-13.4-1.7-26.5-4.4-38.9-9.8C45,546,15.7,512.5,3,464.6c-1.8-6.6-1.5-13.4-2.7-20.1
                        C0.3,434.1,0.3,423.8,0.3,413.5z"/>
                    <g>
                        <path fill="#279AD5" d="M354.8,67.4c-7.1-4.5-14.8-7.5-22.8-9.8c-34.5-10.2-69.9-12.5-105.6-13c-19.3-0.1-38.6,1-57.8,3.3
                            c-21.5,2.6-42.8,6.3-62.9,14.9c-6,2.6-11.7,5.7-16,10.8c-4.5,5.3-4.5,10.9,0.1,16.2c4,4.7,9.2,7.6,14.7,10.1
                            c20.7,9.3,42.9,13,65.2,15.6c28.5,3.3,57.1,4,85.7,2.3c22.1-1.3,44.1-3.8,65.6-9.1c11.7-2.8,23.1-6.4,33.5-12.6
                            C368.9,87.4,369.1,76.4,354.8,67.4z M254.1,88c-12.6,3.7-25.6,4.1-38.6,3.1c-7.1-0.5-14.2-1.4-20.9-4.2c-2.4-1-5.3-2-5.4-5.2
                            c-0.1-3.3,2.8-4.3,5.2-5.3c10.4-4.3,21.4-4.4,30.4-4.8c10.4,0.1,18.8,0.8,27.1,2.9c0.6,0.2,1.3,0.3,1.9,0.5
                            c3.6,1.5,8.9,1.9,8.8,6.7C262.6,86.2,257.6,86.9,254.1,88z"/>
                    </g>
                </g>
            </svg>
            )
        }else if (deviceSubtype === 'kit') {
            return (
                <svg width="58px" height="63px" viewBox="0 0 58 63" version="1.1">
                    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinejoin="round">
                        <g transform="translate(-204.000000, -754.000000)" strokeWidth="2.2">
                            <g transform="translate(206.000000, 756.000000)">
                                <polyline stroke="#2D3441" points="26.9003226 59.6671814 26.9003226 28.3171814 54.0258153 14.5231814"></polyline>
                                <polyline stroke="#2D3441" transform="translate(13.562746, 37.095181) scale(-1, 1) translate(-13.562746, -37.095181) " points="0 59.6671814 0 28.3171814 27.1254927 14.5231814"></polyline>
                                <g transform="translate(10.247742, 4.491181)" stroke="#24A2D9">
                                    <polyline transform="translate(17.405650, 18.810000) scale(-1, 1) translate(-17.405650, -18.810000) " points="0 30.096 7.68580645 33.858 7.68580645 17.556 34.8112991 3.762"></polyline>
                                    <polyline transform="translate(21.248553, 16.929000) scale(-1, 1) translate(-21.248553, -16.929000) " points="15.3716129 33.858 7.68580645 30.096 7.68580645 13.794 34.8112991 0"></polyline>
                                </g>
                                <polygon stroke="#2D3441" strokeLinecap="square" points="9.37198501e-17 13.8961814 26.9003226 -4.15050617e-13 54.0258153 13.8961814 54.0258153 45.6896784 27.0129076 59.6544251 0 45.6896784"></polygon>
                            </g>
                        </g>
                    </g>
                </svg>
            )
        }else if (deviceSubtype === 'biohub') {
            return (
                <img src="https://cherishhealth-assets.s3.us-east-2.amazonaws.com/biohub.png" width="180px" />
            );
        } else {
            deviceSubtype = deviceSubtype.split(' ').join('');
            return (
                <img src={`https://cherishhealth-assets.s3.us-east-2.amazonaws.com/${deviceSubtype}.png`}/>
            )
        }
    }

    const getLink = (devSum) => {
        return '/devices/' + devSum.deviceSubtype.split(' ').join('_');
    }

    const onCardClick = (link) => {
        AuditTrail.sendLog(PAGES.DEVICE_LIST, {tag: 'card', event: 'onClick', action: 'card click detail', link: link});
        navigate(link);
    }

    const displayExpired = false;

    return (
        <div id="DevicesBase">
            <div className="filter">
                <div className="filterOptions">
                    <div className="deviceTitle">
                        <h3>{t('menu:kits-and-devices')}</h3>
                    </div>
                </div>
                <div>

                </div>
                <div className="addAction">
                    <p className="_counter">
                        {peripherals.deviceSummary.reduce((p, c) => p += c.count, 0)} {t('devices')}
                    </p>
                    {
                        peripherals ? '' :
                            <div className="newDeviceAction" onClick={createOrder}>
                                <ButtonIcon>
                                <span className="material-icons">
                                    add
                                </span>
                                </ButtonIcon>
                                <p>{t('order-kits-and-devices')}</p>
                            </div>
                    }
                </div>
            </div>
            <div className="tabs">
                <span className={`${activeTab === 'inventory' ? 'active' : ''}`} onClick={onChangeTab('inventory')}>{t('inventory')}</span>
            </div>
            {
                activeTab === 'inventory' ?
                    <div className="devicesList">
                        <div className="deviceSubtype" onClick={() => onCardClick("/devices/kits")}>
                            <div className="_sumIconTitle">
                                <div className="_iconSvg">
                                    {renderSvgByType('Kit')}
                                </div>
                                <div className="_title">
                                    <h3>
                                        {t('kits-and-devices')}
                                    </h3>
                                    <div className="_info">
                                        <p><b>{peripherals.deviceSummary.reduce((p, c) => p += c.count, 0)}</b> {t('devices')}</p>
                                        <p><b>{peripherals.deviceSummary.reduce((p, c) => p += c.available, 0)}</b> {t('available')}</p>
                                        <p><b>{peripherals.deviceSummary.reduce((p, c) => p += c.assigned? c.assigned : 0, 0)}</b> {t('assigned')}</p>
                                        {
                                            displayExpired? <p><b>{peripherals.deviceSummary.reduce((p, c) => p += c.expired? c.expired : 0, 0)}</b> {t('expired')}</p> : <p></p>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        {peripherals.deviceSummary.map((devSum) => {
                            return (
                                <div key={devSum.deviceSubtype} className="deviceSubtype" onClick={() => onCardClick(getLink(devSum))}>
                                    <div className="_sumIconTitle">
                                        <div className="_iconSvg">
                                                {renderSvgByType(devSum.deviceSubtype)}
                                        </div>
                                        <div className="_title">
                                            <h3>
                                                    {devSum.displayName}
                                            </h3>
                                            <div className="_info">
                                                <p>
                                                    <b>{devSum.count}</b> {t('devices')}
                                                </p>
                                                <p>
                                                    <b>{devSum.available}</b> {t('available')}
                                                </p>
                                                <p>
                                                    <b>{devSum.assigned? devSum.assigned : 0}</b> {t('assigned')}
                                                </p>
                                                {
                                                    displayExpired && devSum.deviceSubtype === 'Biosensor patch'? <p><b>{devSum.expired? devSum.expired : 0}</b> {t('expired')}</p> : <p></p>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div> : '' }
            { loadData? <SpinnerLoader/>: '' }
            {renderModal()}
        </div>
    )
}

export default PageViewLog(DevicesBase);
